import React from 'react'
import Operations from '../../component/reusable/Operations'
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { ArrowDropDown } from '@mui/icons-material';
import NestedUserHeader from '../../component/reusable/NestedUserHeader';
import { useNavigate } from 'react-router-dom';

const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
    borderRadius: 8,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    border: '1px solid #E0E2E7',
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
    fontWeight: 'bold',
    backgroundColor: '#f8f9fa',
    color: '#495057',
    padding: '6px 0px 0px 20px',
    fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
    paddingLeft: '20px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: '6px',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
    color: '#495057',
    fontWeight: 'bold',
    paddingLeft: '20px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));



const AppearancePage = () => {
    const navigate  = useNavigate()
    return (
        <div>
            <NestedUserHeader
                index="Login Page Builder"
                root="Dashboard"
            />

            <TableContainerStyled component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <HeaderCell>
                                ID
                                <IconButton>
                                    <ArrowDropDown />
                                </IconButton>
                            </HeaderCell>

                            <HeaderCell>
                                Pages
                                <IconButton>
                                    <ArrowDropDown />
                                </IconButton>
                            </HeaderCell>

                            <HeaderCell>
                                Last Updated
                                <IconButton>
                                    <ArrowDropDown />
                                </IconButton>
                            </HeaderCell>

                            <HeaderCell>
                                Action
                            </HeaderCell>
                        </TableRow>

                    </TableHead>

                    <TableBody >
                        <TableRow >
                            <TableCells sx={{ width: '25%', }}>
                                1
                            </TableCells>


                            <ProductText sx={{ width: '25%' }}>
                                Home page
                            </ProductText>

                            <TableCells sx={{ width: '30%', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                                29 Dec 2022
                            </TableCells>

                            <Operations
                                TableCells={TableCells}
                                viewClick={() => navigate(`/appearance/view`)}
                                editClick={() => navigate('/appearance/homePage')}
                                hidedelete={'hide'}
                            />

                        </TableRow>
                        <TableRow >
                            <TableCells sx={{ width: '25%', }}>
                                2
                            </TableCells>


                            <ProductText sx={{ width: '25%' }}>
                                Login page
                            </ProductText>

                            <TableCells sx={{ width: '30%', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                                29 Dec 2022
                            </TableCells>

                            <Operations
                                TableCells={TableCells}
                                // viewClick={() => navigate(`/master/viewcategory/${row?._id}`)}
                                editClick={() => navigate('/appearance/loginPage')}
                                hidedelete={'hide'}
                            />

                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainerStyled>
        </div>
    )
}

export default AppearancePage